import comp from "./UserNameAvatar";
export default comp;
